(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["splin-product-videos"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('splin-video-rail')) {
  customElements.define('splin-video-rail', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-step]');
        if (!button) return;
        const rail = this.querySelector('.splin-videos__rail');
        rail.scrollBy({left: Number(button.dataset.step) * rail.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      });
      this.addEventListener('play', event => {
        document.querySelectorAll('splin-video-rail video').forEach(video => { if (video !== event.target) video.pause(); });
      }, true);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
